import type { IconProps } from './../../models/icon';

export function EditIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          fillRule="evenodd"
          d="M7.7442 16.3238L12.8452 15.4056L20.4966 7.72732V21.3569C20.4966 22.296 19.7355 23.0573 18.7964 23.0573H2.6432C1.70414 23.0573 0.942871 22.296 0.942871 21.3569V5.20381C0.942871 4.26474 1.70414 3.50348 2.6432 3.50348H16.2725L8.59436 11.1548L7.7442 16.3238Z"
          clipRule="evenodd"
        />
        <path
          fill="#FDFCFC"
          d="M12.8451 15.4056L7.74414 16.3238L8.59431 11.1548L18.3371 1.44589C18.4954 1.28652 18.6834 1.16002 18.8905 1.0737C19.0978 0.987375 19.3199 0.942932 19.5445 0.942932C19.7689 0.942932 19.9911 0.987375 20.1983 1.0737C20.4056 1.16002 20.5936 1.28652 20.7517 1.44589L22.5541 3.24824C22.7134 3.40631 22.8399 3.59437 22.9263 3.80157C23.0125 4.00876 23.0571 4.23102 23.0571 4.45547C23.0571 4.67994 23.0125 4.90218 22.9263 5.10939C22.8399 5.31659 22.7134 5.50465 22.5541 5.6627L12.8451 15.4056Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12.8451 15.4056L7.74414 16.3238L8.59431 11.1548L18.3371 1.44589C18.4954 1.28652 18.6834 1.16002 18.8905 1.0737C19.0978 0.987375 19.3199 0.942932 19.5445 0.942932C19.7689 0.942932 19.9911 0.987375 20.1983 1.0737C20.4056 1.16002 20.5936 1.28652 20.7517 1.44589L22.5541 3.24824C22.7134 3.40631 22.8399 3.59437 22.9263 3.80157C23.0125 4.00876 23.0571 4.23102 23.0571 4.45547C23.0571 4.67994 23.0125 4.90218 22.9263 5.10938C22.8399 5.31659 22.7134 5.50465 22.5541 5.66271L12.8451 15.4056Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M20.4966 16.256V21.3569C20.4966 21.8079 20.3175 22.2405 19.9986 22.5593C19.6798 22.8782 19.2472 23.0573 18.7964 23.0573H2.6432C2.19224 23.0573 1.75976 22.8782 1.44089 22.5593C1.12201 22.2405 0.942871 21.8079 0.942871 21.3569V5.20381C0.942871 4.75285 1.12201 4.32037 1.44089 4.0015C1.75976 3.68262 2.19224 3.50348 2.6432 3.50348H7.7442"
        />
      </g>
    </svg>
  );
}
